import { Button, Checkbox, Modal } from "antd";

export default function DeleteAssessment({ props }) {
  return (
    <Modal
      visible={props.deleteVisible}
      title="Delete this assessment?"
      onCancel={props.toggleDeletePopup}
      footer={[
        <Button key="Back" onClick={props.toggleDeletePopup}>
          Return
        </Button>,
        <Button
          type="danger"
          key="Delete"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.hardDelete}
        >
          Permanent Delete
        </Button>,
      ]}
    >
      <div className="p-2">{props.assessmentData?.title}</div>

      <div className="p-2">
        <ul>
          <li>
            <p style={{ fontSize: "14px" }}>
              Assessment from episode "{props.assessmentData?.episode?.episode_name}"
            </p>
          </li>
        </ul>
      </div>

      <div className="p-2">
        <strong>Check all</strong> the items below to confirm assessment
        deletion, Deleting a assessment is permanent and <strong>cannot</strong>{" "}
        be undone
      </div>

      <div className="frame-detail">
        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox1(value.target.checked);
            }}
            checked={props.checkBox1}
          >
            Any future access of the data will be impossible
          </Checkbox>
        </div>

        <div>
          <Checkbox
            onChange={(value) => {
              props.setCheckBox2(value.target.checked);
            }}
            checked={props.checkBox2}
          >
            Any record relate to this assessment (assessment response and result) will be permanently delete
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
}